/**
 * Syncs complementary horizontal cards: toggle add-to-cart vs line-item quantity (theme LineItemQuantity flow).
 */
(function () {
  const ICON_STROKE = "1.2";

  function cartChangeHref(lineKey, quantity) {
    const base = `${Shopify.routes.root}cart/change`;
    return `${base}?id=${encodeURIComponent(lineKey)}&quantity=${quantity}`;
  }

  function lineItemForVariant(cart, variantId) {
    const vid = Number(variantId);
    return (cart.items || []).find((item) => Number(item.variant_id) === vid);
  }

  function labelsFrom(actions) {
    return {
      dec: actions.getAttribute("data-i18n-dec") || "Decrease quantity",
      inc: actions.getAttribute("data-i18n-inc") || "Increase quantity",
      qty: actions.getAttribute("data-i18n-qty") || "Change quantity",
    };
  }

  function createSvgPath(d) {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("aria-hidden", "true");
    svg.setAttribute("focusable", "false");
    svg.setAttribute("fill", "none");
    svg.setAttribute("width", "10");
    svg.setAttribute("class", "icon");
    svg.setAttribute("viewBox", "0 0 12 12");
    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
    path.setAttribute("d", d);
    path.setAttribute("stroke", "currentColor");
    path.setAttribute("stroke-width", ICON_STROKE);
    svg.appendChild(path);
    return svg;
  }

  function createQtyLink(href, srText, pathD) {
    const a = document.createElement("a");
    a.href = href;
    a.className = "quantity-selector__button";
    const sr = document.createElement("span");
    sr.className = "sr-only";
    sr.textContent = srText;
    a.append(sr, createSvgPath(pathD));
    return a;
  }

  function createLineItemQuantityRoot(item, labels) {
    const wrap = document.createElement("line-item-quantity");
    wrap.className = "horizontal-product-card__line-item-qty";

    const sel = document.createElement("quantity-selector");
    sel.className = "quantity-selector quantity-selector--sm";
    sel.setAttribute("data-hulkapps-lineitem", "");

    const dec = createQtyLink(
      cartChangeHref(item.key, Math.max(0, item.quantity - 1)),
      labels.dec,
      "M0 6h12"
    );

    const input = document.createElement("input");
    input.className = "quantity-selector__input text-sm";
    input.type = "number";
    input.setAttribute("is", "quantity-input");
    input.value = String(item.quantity);
    input.inputMode = "numeric";
    input.setAttribute("data-line-key", item.key);
    input.setAttribute("aria-label", labels.qty);

    const inc = createQtyLink(
      cartChangeHref(item.key, item.quantity + 1),
      labels.inc,
      "M6 0v12M0 6h12"
    );

    sel.append(dec, input, inc);
    wrap.appendChild(sel);
    return wrap;
  }

  function patchExistingQty(wrap, item) {
    const input = wrap.querySelector("[data-line-key]");
    if (!input || input.getAttribute("data-line-key") !== String(item.key)) {
      return false;
    }
    input.value = String(item.quantity);
    const links = wrap.querySelectorAll('a[href*="cart/change"]');
    if (links[0]) links[0].href = cartChangeHref(item.key, Math.max(0, item.quantity - 1));
    if (links[1]) links[1].href = cartChangeHref(item.key, item.quantity + 1);
    return true;
  }

  function mountOrPatchQty(wrapper, item, labels) {
    if (patchExistingQty(wrapper, item)) return;
    wrapper.replaceChildren(createLineItemQuantityRoot(item, labels));
  }

  function syncCard(actionsRoot, cart) {
    const variantId = actionsRoot.getAttribute("data-variant-id");
    if (!variantId || !cart) return;

    const lineItem = lineItemForVariant(cart, variantId);
    const cta = actionsRoot.querySelector(".horizontal-product-card__cta");
    const qtyWrap = actionsRoot.querySelector(".horizontal-product-card__quantity-wrapper");
    if (!cta || !qtyWrap) return;

    const labels = labelsFrom(actionsRoot);

    if (lineItem && lineItem.quantity > 0) {
      cta.hidden = true;
      qtyWrap.hidden = false;
      mountOrPatchQty(qtyWrap, lineItem, labels);
    } else {
      cta.hidden = false;
      qtyWrap.hidden = true;
      qtyWrap.replaceChildren();
    }
  }

  function syncAll(cart) {
    document.querySelectorAll("[data-horizontal-rec-actions]").forEach((el) => syncCard(el, cart));
  }

  function fetchCartAndSync() {
    fetch(`${Shopify.routes.root}cart.js`)
      .then((r) => r.json())
      .then(syncAll)
      .catch(() => {});
  }

  function scheduleInitialSync() {
    fetchCartAndSync();
    requestAnimationFrame(fetchCartAndSync);
    setTimeout(fetchCartAndSync, 100);
  }

  function watchDomForRecCards() {
    if (!document.body) return;
    let t = 0;
    const obs = new MutationObserver(() => {
      if (!document.querySelector("[data-horizontal-rec-actions]")) return;
      clearTimeout(t);
      t = window.setTimeout(fetchCartAndSync, 40);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener("cart:change", (e) => {
    if (e.detail?.cart) syncAll(e.detail.cart);
  });

  document.addEventListener("product-recommendations:loaded", fetchCartAndSync);

  const boot = () => {
    scheduleInitialSync();
    watchDomForRecCards();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();